import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import {urlParse} from '../assets/js/_mm.js'
import Home from '@/pages/home/Home'
import CPlan from '@/pages/c-plan/c-plan'
import Record from '@/pages/record/Record'
import InsertPlan from '@/pages/insert-plan/insert-plan'
import Plan from '@/pages/plan/plan'
import DReport from '@/pages/d-report/d-report'
import Register from '@/pages/register/Register'
import Detail from '@/pages/detail/detail'
import Sets from '@/pages/set/set'
import EnterPlan from "@/pages/enter-plan/index"
Vue.use(Router)

const router =  new Router({
  routes: [
  	{
  		path: '/',
  		redirect: '/home'
  	},
    {
    	path: '/home',
    	name: 'Hmoe',
    	component: Home
    },
    {
      path: '/plan',
      name: 'Plan',
      component: Plan
    },
    {
    	path: '/c-plan',
    	name: 'CPlan',
    	component: CPlan,
    },
    {
      path: '/record',
      name: 'Record',
      component: Record
    },
    {
      path: '/d-report/:date*',
      props: true,
      name: 'DReport',
      component: DReport
    },
    {
      path: '/insert-plan/:params*',
      props: true,
      name: 'InsertPlan',
      component: InsertPlan
    },
    {
      path: '/register/:param*',
      props: true,
      name: 'Register',
      component: Register
    },
    {
      path: '/detail',
      name: 'Detail',
      component: Detail
    },
    {
      path: '/sets',
      name: 'Sets',
      component: Sets
    },
    {
      path: '/enter-plan',
      name: 'EnterPlan',
      component: EnterPlan
    }
  ]
})

router.beforeEach((to, from, next) => {
  let urlParams = urlParse()
  store.commit('getUserInfo', urlParams)
  next()
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js